import React from 'react';
import { useParams } from 'react-router-dom';
import AppAnalysisDetailsView from './AppAnalysisDetailsView';
import useAppAnalysisDetailsLogic from './AppAnalysisDetailsLogic';

const AppAnalysisDetails = () => {
  // Extract fileId from URL params
  const { fileId } = useParams();
  
  // Use the logic hook to fetch data
  const { appDetails, loading, error } = useAppAnalysisDetailsLogic(fileId);
  
  return (
    <AppAnalysisDetailsView 
      appDetails={appDetails}
      loading={loading}
      error={error}
    />
  );
};

export default AppAnalysisDetails; 